import { Box, Flex, Stack } from '../../../../shared/layouts';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Button from '../../../../shared/Button';
import Modal from '../../../../shared/Modal';
import { useContext, useEffect, useState } from 'react';
import Input from '../../../../shared/Input';
import MessagebarContext from '../../../../../context/MessagebarContext';
import { useNavigate } from 'react-router-dom';
import RadioButton from '../../../../shared/RadioButton';

const SaveCalculationModal = ({
  isOpen,
  onRequestClose,
  submitData = {},
  currentResults,
  nhgResultOptions
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setSuccesMessage, setAlertMessage } = useContext(MessagebarContext);
  const [calculationName, setCalculationName] = useState('');
  const [saveNhgResult, setSaveNhgResult] = useState('without_nhg');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState(null);

  const handleSubmit = () => {
    setIsSubmitting(true);
    setErrors(null);

    axios
      .post('/calculations', {
        type: 'calculation',
        name: calculationName,
        input: submitData,
        output: {
          max_mortgage: currentResults?.[saveNhgResult]?.maximum_mortgage,
          frt: currentResults?.frt_years,
        }
      })
      .then(() => {
        setSuccesMessage(t('Berekening is opgeslagen'));
        navigate('/calculations/overview');
        onRequestClose();
      })
      .catch(err => {
        const errorResponse = err?.response?.data;
        setErrors(errorResponse?.errors);
        setAlertMessage(errorResponse?.message);
        setIsSubmitting(false);
      });
  };

  useEffect(() => {
    setCalculationName('');
    setIsSubmitting(false);
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
      <Stack space={'l'}>
        <Stack space={'m'}>
          <Box fontScale={'l'} fontWeight={'bold'}>
            {t('Hoe wil je de berekening noemen?')}
          </Box>
          <Input
            placeholder={t('Naam berekening')}
            value={calculationName}
            onChange={({ target }) => {
              setCalculationName(target.value);
            }}
            errors={errors?.name}
          />
        </Stack>
        <Stack space={'m'}>
          <Box fontScale={'l'} fontWeight={'bold'}>
            {t('Is het gewenste resultaat met of zonder NHG?')}
          </Box>
          <RadioButton
            name={'save_nhg_result'}
            value={saveNhgResult}
            onChange={value => setSaveNhgResult(value)}
            options={nhgResultOptions}
            direction={'row'}
          />
        </Stack>
        <Flex
          pt={'s'}
          flexDirection={{ mobile: 'column-reverse', desktop: 'row' }}
          justifyContent={{ mobile: 'flex-start', desktop: 'flex-end' }}
          css={({ space }) => ({ gap: space.m })}
        >
          <Button
            variant="primary-outline"
            width={{ mobile: '100%', desktop: 'auto' }}
            onClick={onRequestClose}
            disabled={isSubmitting}
          >
            {t('Annuleren')}
          </Button>
          <Button
            variant="primary"
            width={{ mobile: '100%', desktop: 'auto' }}
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {t('Opslaan')}
          </Button>
        </Flex>
      </Stack>
    </Modal>
  );
};

export default SaveCalculationModal;
